import React from 'react';
import { observer } from 'mobx-react-lite';
import { FormInputState } from 'src_common/common/mobx-utils/Form';
import { OptionElement } from 'src/domains/layouts/shared/formComponents/Select/SelectNative.style';
import { SelectNative } from 'src/domains/layouts/shared/formComponents/Select/SelectNative';
import { SelectNativeStateOld } from 'src/domains/layouts/shared/formComponents/Select/SelectNativeStateOld.state';

interface SelectOptionsType {
    key: string;
    name: string;
}

interface QuickLinkTraySelectType {
    className?: string;
    dataTest?: string;
    onChangeCB?: (value: string) => void;
    selectOptions: Array<SelectOptionsType>;
    stateValue: FormInputState<string>;
}

/**
 * @deprecated - Please use Select.tsx or OldSelect.tsx from layouts/shared instead
 */

export const QuickLinkTraySelect = observer(({className, selectOptions, stateValue, dataTest, onChangeCB}: QuickLinkTraySelectType) => {
    const [ state ] = React.useState(() => new SelectNativeStateOld(stateValue, onChangeCB));
    
    return (
        <SelectNative
            className={className}
            dataTest={dataTest}
            onChange={state.onChange}
            value={stateValue.value}
        >
            {selectOptions.length > 0 ?
                <>
                    {selectOptions.map((option: SelectOptionsType) => {
                        return (
                            <OptionElement key={option.key} value={option.key}>
                                {option.name}
                            </OptionElement>
                        );
                    })}
                </> : null }
        </SelectNative>
    );
});
